import {
  USER_SET_IS_RBICONNECT,
  USER_SET_USER_ACCESS,
  USER_SET_USER_BRANDS,
  USER_SET_USER_INFO,
  USER_SET_USER_PERMISSIONS,
  USER_SET_USER_ROLES,
} from '../action-types/user-types';

const initialState = {
  permissions: [],
  userInfo: {},
  loading: false,
  roles: [],
  isRBIConnect: false,
  brands: [],
  thisUser: {},
};
export default function (state = initialState, action) {
  switch (action.type) {
    case USER_SET_USER_INFO:
      return {
        ...state,
        loading: false,
        userInfo: action.payload,
      };
    case USER_SET_USER_PERMISSIONS:
      return {
        ...state,
        loading: false,
        permissions: action.payload,
      };
    case USER_SET_USER_ROLES:
      return {
        ...state,
        loading: false,
        roles: action.payload,
      };
    case USER_SET_IS_RBICONNECT:
      return {
        ...state,
        loading: false,
        isRBIConnect: true,
        brands: [
          {
            brandId: 1,
            brandCode: 'BK',
            brandName: 'Burger King',
          },
          {
            brandId: 2,
            brandCode: 'PLK',
            brandName: 'Popeyes',
          },
          {
            brandId: 3,
            brandCode: 'TH',
            brandName: 'Tim Hortons',
          },
        ],
      };
    case USER_SET_USER_BRANDS:
      return {
        ...state,
        loading: false,
        brands: action.payload,
      };
    case USER_SET_USER_ACCESS:
      return {
        ...state,
        thisUser: action.payload,
      };
    default:
      return state;
  }
}
